module.exports = __webpack_public_path__ + "static/scene-5.915dbaf0.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/scene-5.png
// module id = 304
// module chunks = 2